import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import { parse } from 'hub-http/helpers/params';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import UIApplication from 'UIComponents/app/UIApplication';
import UIBox from 'UIComponents/layout/UIBox';
import { getAppShortlink, getCmsFreeSignupUrl } from 'ecosystem-marketplace-core/assets/utils/urls';
import MarketingNavHeader from 'ecosystem-marketplace-core/components/nav/MarketingNavHeader';
import MarketingNavFooter from 'ecosystem-marketplace-core/components/nav/MarketingNavFooter';
import { useWindowDimensionsContext } from 'ecosystem-marketplace-core/hooks/useWindowDimensionsContext';
import { getThemeDetailsSlug } from 'marketplace-assets-base/selectors/themeDetails';
import { getFullPublicUrl } from 'marketplace-assets-base/utils/urls';
const GRID_BREAKPOINT_MEDIUM_INT = parseInt(GRID_BREAKPOINT_MEDIUM, 10);
const languagesContent = {
  en: ['English'],
  jp: ['日本語'],
  de: ['Deutsch'],
  es: ['Español'],
  pt: ['Português'],
  fr: ['Français']
};
const StyledUIApplication = styled(UIApplication).withConfig({
  displayName: "AppContainer__StyledUIApplication",
  componentId: "sc-1iz9e71-0"
})(["display:flex;flex-direction:column;"]);
const StyledMainContent = styled(props => /*#__PURE__*/_jsx(UIBox, Object.assign({}, props, {
  grow: 1,
  shrink: 1
}))).withConfig({
  displayName: "AppContainer__StyledMainContent",
  componentId: "sc-1iz9e71-1"
})(["min-height:100vh;"]);

const AppContainer = ({
  children,
  name
}) => {
  const lang = getLang();
  const {
    pathname,
    search
  } = useLocation();
  const query = parse(search.slice(1));
  const themeDetailsSlug = useSelector(getThemeDetailsSlug) || undefined;
  const hydratedLanguagesContent = useMemo(() => {
    return Object.keys(languagesContent).reduce((final, langKey) => {
      const [langName] = languagesContent[langKey];
      const url = `${getFullPublicUrl(langKey)}${pathname}`.replace(/\/?$/, '');
      return Object.assign({}, final, {
        [langKey]: [langName, `${url}${search}`, '']
      });
    }, {});
  }, [pathname, search]);
  const headerContentBlob = useMemo(() => {
    return {
      upperNavContent: {
        loginUrl: getAppShortlink({
          pathname,
          query,
          theme: themeDetailsSlug
        }),
        regionalDropdownContent: {
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        languagesContent: hydratedLanguagesContent
      },
      navCta: {
        navCtaUrl: getCmsFreeSignupUrl(themeDetailsSlug),
        navCtaText: I18n.text('marketplace-assets-ui.storefront.publicNav.navCtaText')
      }
    };
  }, [hydratedLanguagesContent, pathname, query, themeDetailsSlug]);
  const {
    width: windowWidth
  } = useWindowDimensionsContext();
  const headerVariation = windowWidth < GRID_BREAKPOINT_MEDIUM_INT ? 'default' : 'marketplace';
  return /*#__PURE__*/_jsxs(StyledUIApplication, {
    name: name,
    children: [/*#__PURE__*/_jsx(MarketingNavHeader, {
      contentBlob: headerContentBlob,
      enableConvertFlag: true,
      lang: lang,
      variation: headerVariation
    }), /*#__PURE__*/_jsx(StyledMainContent, {
      children: children
    }), /*#__PURE__*/_jsx(MarketingNavFooter, {
      lang: lang
    })]
  });
};

export default AppContainer;